import { ColorizeRounded as ColorizeRoundedIcon } from '@mui/icons-material';
import {
    Box,
    Chip,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import ColorPopover from '../branding/branding-color-popover';
import { integrateModuleURL } from 'src/services/urlService';
import HttpServices from 'src/services/httpService';

const ImageConfigurationComponent = ({
  numberOfImagesToGenerate,
  imageColor,
  isUseBrandDetails,
  selectedStyleType,
  selectedAspectRatio,
  selectedPostGenerationType,
  formErrors,
  blogUrl,
  handleFields,
  selectedModel,
  setSelectedModel,
  imageModels
}) => {
  const AspectRatioList = [
    { label: '9:16', value: '9x16' },
    { label: '16:9', value: '16x9' },
    { label: '1:1', value: '1x1' },
  ];
  const NumberList = [1, 2, 3, 4, 5];
  const [popoverElement, setPopoverElement] = useState(null);
  const [models, setModels] = useState([]);
  const [modelLoading, setModelLoading] = useState(false);

  const handleCloseColorPalette = () => {
    setPopoverElement(null);
  };

  const handleColor = (color, type) => {
    handleFields(color.hex, 'imageColor');
  };

  const colorPaletteProps = {
    popoverElement: popoverElement,
    handleCloseMenu: handleCloseColorPalette,
    handleColor,
    color: imageColor,
  };

  useEffect(() => {
    setModelLoading(true);
    HttpServices.Get({
      url: integrateModuleURL.getAllImageModels,
      successCallback: (data) => {
        setModels(data || []);
        setModelLoading(false);
        if (data && data.length > 0 && !selectedModel) {
          setSelectedModel(data[0]);
        }
      },
      failureCallback: () => setModelLoading(false),
    });
  }, []);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel>Number of Posts</InputLabel>
            <Select
              name="numberOfImagesToGenerate"
              value={numberOfImagesToGenerate}
              onChange={(e) => handleFields(e.target.value, 'numberOfImagesToGenerate')}
              label="Number of Posts"
            >
              {NumberList.map((number) => (
                <MenuItem key={number} value={number}>
                  {number}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>


        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <StyledComponent.SwitchIcon
                sx={{ m: 1 }}
                name="useBrandDetails"
                checked={isUseBrandDetails}
                onChange={() => handleFields(!isUseBrandDetails, 'useBrandDetails')}
              />
            }
            label="Use Brand Details"
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControl fullWidth disabled={modelLoading}>
            <InputLabel>Image Model</InputLabel>
            <Select
              name="imageModel"
              value={selectedModel ? selectedModel.model : ''}
              onChange={e => {
                const model = models.find(m => m.model === e.target.value);
                setSelectedModel(model);
              }}
              label="Image Model"
            >
              {models.map((model) => (
                <MenuItem key={model.model} value={model.model}>
                  {model.display_text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12}>
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1.5 }}>
              Aspect Ratio
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {AspectRatioList.map((size) => (
                <Chip
                  key={size.value}
                  label={size.label}
                  onClick={() => handleFields(size.value, 'aspectRatio')}
                  sx={{
                    borderRadius: 8,
                    ...(selectedAspectRatio === size.value && {
                      bgcolor: 'primary.main',
                      color: 'white',
                      fontWeight: 'bold',
                    }),
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'primary.main',
                      color: 'white',
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        </Grid>
        {selectedPostGenerationType === 'blog_to_image' && (
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              name="blogUrl"
              value={blogUrl}
              label="Enter Blog URL"
              margin="normal"
              onChange={(e) => {
                handleFields(e.target.value.replaceAll(' ', ''), 'blogUrl');
              }}
              error={!!formErrors?.blogUrl}
              helperText={formErrors?.blogUrl}
            />
          </Grid>
        )}
      </Grid>

      <ColorPopover {...colorPaletteProps} />
    </>
  );
};

export default ImageConfigurationComponent;
